export default __webpack_public_path__ + "static/media/home-split-portfolio-img-03.ccce2278.jpg";